export default __webpack_public_path__ + "static/media/Ad.4d1bcd77.mp4";